import { render, staticRenderFns } from "./AiAssistantWidget.vue?vue&type=template&id=96971ba0&scoped=true&"
import script from "./AiAssistantWidget.vue?vue&type=script&lang=js&"
export * from "./AiAssistantWidget.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantWidget.vue?vue&type=style&index=0&id=96971ba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96971ba0",
  null
  
)

export default component.exports